<template>
  <span>
    <div class="attachment">
      <div class="icon"><i class="fal fa-file"></i></div>
      <div class="information">
        <div class="name" v-b-tooltip.hover :title="info.name">{{ info.name }}</div>
        <div class="filesize">
          {{bytesToSize(info.size)}}
        </div>
         <div class="remove">
          <i class="fal fa-trash-alt pr-2 clickable" @click="removeFile(index)"></i>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
export default {
  props: ["item","index","percent"],
  data() {
    return {
      loading: false,
      info: this.item,
      blob: null
    };
  },
  methods: {
    removeFile(index) {
      this.$emit("removeFile",index);
    },
    bytesToSize(bytes, decimals = 2) {
      if (bytes === 0) return "0";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
  }
};
</script>
<style>
</style>